module.exports = __webpack_public_path__ + "img/digit-2.c13aea59.png";